import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/sheth-promont-logo.svg"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Sheth Realty"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        <strong>Sheth Realty</strong> is a pioneering real estate developer
        known for its iconic residential and commercial projects across Mumbai.
        With a commitment to excellence, Sheth Realty integrates sustainable
        design, top-tier amenities, and innovative construction techniques. Each
        project is meticulously planned to offer comfort, convenience, and
        long-term value, making them the preferred choice for homebuyers and
        investors. <br />
        <b>A Legacy of Excellence | Innovative Design | Timely Delivery</b>
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-P51800056060.webp" alt="rera qr" />
          <strong>P51800056060</strong>
        </div>
      </div>
      <span className="pro-rera text-center-mob">
        <strong>Sheth Realty</strong> has been registered via MahaRERA
        registration number and is available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>
      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
